var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53301 10.9997H2.46634V19.533C2.46634 20.0988 2.6911 20.6414 3.09118 21.0415C3.49126 21.4416 4.03388 21.6663 4.59967 21.6663H9.93301V10.9997H3.53301ZM17.3997 10.9997H12.0663V21.6663H17.3997C17.9655 21.6663 18.5081 21.4416 18.9082 21.0415C19.3082 20.6414 19.533 20.0988 19.533 19.533V10.9997H17.3997ZM18.2434 5.66634C18.3985 5.14742 18.4737 4.6079 18.4663 4.06634C18.4663 2.00767 16.7917 0.333008 14.733 0.333008C13.0029 0.333008 11.8477 1.91381 11.1021 3.62367C10.3671 2.00767 9.15328 0.333008 7.26634 0.333008C5.20767 0.333008 3.53301 2.00767 3.53301 4.06634C3.53301 4.70207 3.61727 5.22794 3.75594 5.66634H0.333008V9.93301H9.93301V7.79967H12.0663V9.93301H21.6663V5.66634H18.2434ZM5.66634 4.06634C5.66634 3.18421 6.38421 2.46634 7.26634 2.46634C8.21354 2.46634 9.09461 4.09301 9.61088 5.66634H6.73301C6.33408 5.66634 5.66634 5.66634 5.66634 4.06634ZM14.733 2.46634C15.6151 2.46634 16.333 3.18421 16.333 4.06634C16.333 5.66634 15.6653 5.66634 15.2663 5.66634H12.6242C13.1682 3.98527 13.9586 2.46634 14.733 2.46634Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e25ccf936d4f5378adff5206a688a929.svg";
export { ForwardRef as ReactComponent };